<template>
  <div :id="`PaginationText_${context}`" :class="`paginationText ${cssClasses}`">
    <strong>{{ paginationText }}</strong>
  </div>
</template>

<script>
  export default{
    props: {
      pageSize: Number,
      currentPage: Number,
      numberOfResults: Number,
      context: String,
      cssClasses: String
    },
    computed: {
      paginationText() {
        let perPage = this.pageSize;
        let currentPage = this.currentPage;
        let numOfResults = this.numberOfResults;

        let startNum = ((currentPage - 1) * perPage) + 1;        
        let endNum = numOfResults < currentPage * perPage 
          ? numOfResults
          : currentPage * perPage;

        if(numOfResults === 0){
          startNum = 0;
        }

        return `${startNum} - ${endNum} of ${numOfResults}`
      }
    }
  }
</script>